import { Moment } from 'moment';
import { BasicStudent } from './basic-student';
import { Country } from './country';
import { SalesAgent } from './sales-agent';
import { School } from './school';
import { StudentLanguage } from './student-language';

//simple DTO to make new booking for Bruges/VND. can be deleted after updating booking creation process.
export class BasicBrugesVndBooking {

    constructor(
        public startDate: Moment,
        public endDate: Moment,
        public studentLanguage: StudentLanguage,
        public school: School,
        public destination: Country,
        public student: BasicStudent,
        public agent: SalesAgent,
        public uuid?: string
    ){}
}
